import React, { Component, Fragment } from "react";
import "../../styles/Popup.module.css";
import { Form, Select, Input, TimePicker } from "antd";
import { connect } from "react-redux";
import { requestServerPost, selectPage } from "../../actions";
import PopupManager from "../../managers/PopupManager";
import moment from "moment";
import { GitBranch } from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const formItemLayout = {
  layout: "vertical",
};

class CreateBranchPage extends Component {
  constructor(props) {
    super(props);
    this.state = { fileList: [] };
  }

  normFile = (e) => {
    // console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  onChange = ({ fileList: newFileList }) => {
    // console.log("onChange " + JSON.stringify(newFileList))
    this.setState({ fileList: newFileList });
  };

  onPreviewDrop = (files) => {
    this.setState({
      files: this.state.fileList.concat(files),
    });
  };

  onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  onFinish = (values) => {
    const {
      requestServerPost,
      usertoken,
      selectedBrandData,
      data = null,
    } = this.props;
    var params = new FormData();

    if (data) {
      params.append("branchid", data.BranchID);
      params.append("branchname", values.branchname);

      if (values.branchopentime && values.branchopentime.length > 0) {
        params.append("opentime", values.branchopentime[0].format("HH:mm:ss"));
        params.append("closetime", values.branchopentime[1].format("HH:mm:ss"));
      }

      requestServerPost(
        "update_branch",
        params,
        {},
        (response) => {
          // console.log("create brand success")
          PopupManager.closePopup();
        },
        usertoken,
      );
    } else {
      params.append("brandid", selectedBrandData.BrandID);
      params.append("branchname", values.branchname);

      if (values.branchopentime && values.branchopentime.length > 0) {
        params.append("opentime", values.branchopentime[0].format("HH:mm:ss"));
        params.append("closetime", values.branchopentime[1].format("HH:mm:ss"));
      }

      requestServerPost(
        "create_branch",
        params,
        {},
        (response) => {
          // console.log("create brand success")
          PopupManager.closePopup();
        },
        usertoken,
      );
    }
  };

  render() {
    const {
      requestServerPost,
      usertoken,
      selectedBrandData,
      data = null,
      langT,
    } = this.props;
    const t = langT || {
      createTitle: "Create a New Location",
      createSub: "Set up your location name and opening hours",
      editTitle: "Edit Location",
      editSub: (name) => `Editing "${name}"`,
      branchNameLabel: "Location Name",
      branchNamePlaceholder: "e.g. Downtown Store",
      branchNameRequired: "Please enter a location name",
      openingHours: "Opening Hours",
      openingHoursRequired: "Please select opening hours",
      saveChanges: "Save Changes",
      createBtn: "Create Location",
    };
    const previewStyle = {
      display: "inline",
      width: 100,
      height: 100,
    };
    const bleed = { margin: -24, overflow: "hidden" };
    const body = { maxWidth: 440, margin: "0 auto", padding: "32px 40px" };

    return (
      <div style={{ ...bleed }}>
        <div
          style={{
            background: "linear-gradient(135deg,#6366f1 0%,#4f46e5 100%)",
            padding: "36px 40px",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 16,
              background: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 14px",
            }}
          >
            <GitBranch size={28} color="#fff" />
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>
            {data ? t.editTitle : t.createTitle}
          </div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.75)" }}>
            {data ? t.editSub(data.BranchName) : t.createSub}
          </div>
        </div>
        <div style={{ ...body }}>
          <Form
            name="create_branch_form"
            {...formItemLayout}
            key={
              data ? `${data.BranchID}_form_createbranch` : "form_createbranch"
            }
            onFinish={this.onFinish}
            initialValues={{
              branchname: data ? data.BranchName : "",
              branchopentime: data
                ? [
                    moment(data.OpenTime, "HH:mm:ss"),
                    moment(data.CloseTime, "HH:mm:ss"),
                  ]
                : selectedBrandData
                  ? [
                      moment(selectedBrandData.DefaultOpenTime, "HH:mm:ss"),
                      moment(selectedBrandData.DefaultCloseTime, "HH:mm:ss"),
                    ]
                  : ["10:00:00", "22:00:00"],
            }}
          >
            <div style={{ marginBottom: 20 }}>
              <label
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                {t.branchNameLabel}
              </label>
              <Form.Item
                name="branchname"
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: t.branchNameRequired }]}
              >
                <Input
                  size="large"
                  placeholder={t.branchNamePlaceholder}
                  style={{ borderRadius: 10 }}
                  autoFocus
                />
              </Form.Item>
            </div>
            <div style={{ marginBottom: 28 }}>
              <label
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                {t.openingHours}
              </label>
              <Form.Item
                name="branchopentime"
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: t.openingHoursRequired }]}
              >
                <TimePicker.RangePicker
                  size="large"
                  style={{ width: "100%", borderRadius: 10 }}
                  format="HH:mm"
                />
              </Form.Item>
            </div>
            <Form.Item style={{ marginBottom: 0 }}>
              <button
                type="submit"
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 10,
                  border: "none",
                  background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                  color: "#fff",
                  fontSize: 15,
                  fontWeight: 600,
                  cursor: "pointer",
                  boxShadow: "0 2px 10px rgba(99,102,241,0.3)",
                }}
              >
                {data ? t.saveChanges : t.createBtn}
              </button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

const Styles = {};

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    selectedBrandData: state.selectedBrandData,
  };
};

const ConnectedCreateBranchPage = connect(mapStateToProps, {
  requestServerPost,
  requestServerPost,
  selectPage,
})(CreateBranchPage);

const CreateBranchPageWithLang = (props) => {
  const { lang } = useProLanguage();
  const t = PRO_TRANSLATIONS[lang].branch;
  return <ConnectedCreateBranchPage langT={t} {...props} />;
};

export default CreateBranchPageWithLang;
